export default __webpack_public_path__ + "static/media/bookos-bold.0eeb8f1b.ttf";